import { render, staticRenderFns } from "./Pet.vue?vue&type=template&id=3db6eb05&scoped=true&"
import script from "./Pet.vue?vue&type=script&lang=js&"
export * from "./Pet.vue?vue&type=script&lang=js&"
import style0 from "./Pet.vue?vue&type=style&index=0&id=3db6eb05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db6eb05",
  null
  
)

export default component.exports